import { initReactI18next } from 'react-i18next'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'

export default function loadTranslations() {
  return new Promise((resolve, reject) => {
    i18n
      .use(Backend)
      .use(LanguageDetector)
      .use(initReactI18next)
      .init(
        {
          fallbackLng: 'en',
          backend: {
            loadPath:
              'https://xeltotranslations.blob.core.windows.net/platform/{{lng}}.json',
            queryStringParams: { v: new Date().getTime() },
            reloadInterval: false,
            requestOptions: {
              // Ignore HTTP errors and continue initialization
              // Then i18next will use fallbackLng (pl)
              mode: 'cors',
              credentials: 'same-origin',
              cache: 'default',
            },
          },
          // Always load "pl" as a backup language, even if another language is not available
          load: 'currentOnly',
          preload: ['en'],
          // This option prevents i18next from interrupting initialization when a resource is not found
          partialBundledLanguages: true,
          initImmediate: false,
          interpolation: {
            escapeValue: false,
          },
          react: {
            useSuspense: true,
          },
          detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
          },
        },
        (err, t) => {
          if (err) {
            // Even if an error occurs, try to load Polish as a fallback language
            i18n
              .changeLanguage('en')
              .then(() => resolve(t))
              .catch((finalErr) => reject(finalErr))
          } else {
            resolve(t)
          }
        },
      )
  })
}
